import { withStyles } from "@material-ui/styles";
import PageBemVindoMeuINSS from "./PageBemVindoMeuINSS";
import PoliticaPrivacidade from './PoliticaPrivacidade';
import React from 'react';

const styles = theme => ({
    firstNavigationButton: {
        height: "48px",
        width: "48px",
        color: '#ffffff',
        border: "1px solid white",
        borderRadius: "100em",
        marginBottom: "60px"
    },
    swipe_area: {
        height: '100%',
        zIndex: 99999,
    },
    stepperButton: {
        fontSize: '0.9em',
        textTransform: 'none',
        color: '#ffffff'
    },
    navigation_buttons: {
        position: 'absolute',
        top: '0',
        width: '100%',
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        alignItems: "end",
        zIndex: "9999"
    },
    ballsContainer: {
        width: '100%',
        position: "absolute",
        top: "0",
        display: 'flex',
        justifyContent: "center",
        height: "100vh",
        alignItems: "end",
    },
    balls: {
        height: '21px',
        display: 'flex',
        position: 'fixed',
        marginBottom: "20px"
    },
    ballsContainer_bottom: {
        width: '100%',
        display: 'block',
        position: 'absolute',
        bottom: '3rem'
    },
    balls_div: {
        flex: '1',
        borderRadius: '20px',
        width: '10px',
        margin: '2px'
    },
    navigation_buttons_bottom: {
        width: '100%',
        padding: '20px',
        height: '40px',
    },
    inactive: {
        border: '1px solid #bbbbbb',
        borderRadius: '100em',
        backgroundColor: '#bbbbbb',
        width: '8px',
        height: "8px",
        margin: '12px 4px 2px 4px'
    },
    active: {
        border: '1px solid #2642a7',
        borderRadius: '100em',
        backgroundColor: '#2642a7',
        width: '8px',
        height: "8px",
        margin: '12px 4px 2px 4px'
    }
})

class SwipableOnboardScreen extends React.Component {

    state = {
        page: 0
    }

    componentDidMount() {
        if(!localStorage.getItem('onBoardScreenShowed')) {
            localStorage.setItem('onBoardScreenShowed', false);
        }
    }

    render() {
        const { classes } = this.props;
        return (
                <>
                    {
                        this.state.page === 0 ?
                            <PageBemVindoMeuINSS callback={() => this.setState({page: 1})} />
                            :
                            <PoliticaPrivacidade />
                    }
                </>
        )
    }
}

export default withStyles(styles)(SwipableOnboardScreen);
